import React from 'react';
import { components } from 'react-select';
export default /*#__PURE__*/React.memo(function (props) {
  var _props$selectProps;
  return components.DropdownIndicator && /*#__PURE__*/React.createElement(components.DropdownIndicator, props, (_props$selectProps = props.selectProps) === null || _props$selectProps === void 0 ? void 0 : _props$selectProps.dropDownIcon);
});